import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Appointment {
	id: number;
	appointment_date: string;
	start_time: string;
	end_time: string;
	status: string;
	is_consultation: boolean;
	total_amount: number;
	service?: { id: number; service_name: string };
	staff?: { id: number; first_name: string; last_name: string };
}

export interface Customer {
	id: number;
	first_name: string;
	last_name: string;
	full_name: string;
	email: string;
	phone: string;
	has_had_consultation: boolean;
	notes: string;
	user_id?: number;
	created_at: string;
	updated_at: string;
	appointments?: Appointment[];
}

export interface PaginatedResponse<T> {
	current_page: number;
	data: T[];
	last_page: number;
	per_page: number;
	total: number;
}

export interface ApiResponse<T> {
	status: boolean;
	data: T;
	message?: string;
}

@Injectable({
	providedIn: 'root',
})
export class CustomerService {
	private http = inject(HttpClient);
	private apiUrl = environment.apiUrl;

	getAll(search?: string, page: number = 1): Observable<ApiResponse<PaginatedResponse<Customer>>> {
		let params = new HttpParams().set('page', page.toString());
		if (search) params = params.set('search', search);
		return this.http.get<ApiResponse<PaginatedResponse<Customer>>>(`${this.apiUrl}/admin/customers`, { params });
	}

	getById(id: number): Observable<ApiResponse<Customer>> {
		return this.http.get<ApiResponse<Customer>>(`${this.apiUrl}/admin/customers/${id}`);
	}

	getWithAppointments(id: number): Observable<ApiResponse<Customer>> {
		return this.http.get<ApiResponse<Customer>>(`${this.apiUrl}/admin/customers/${id}/appointments`);
	}

	findByPhone(phone: string): Observable<ApiResponse<Customer>> {
		return this.http.get<ApiResponse<Customer>>(`${this.apiUrl}/admin/customers/phone/${encodeURIComponent(phone)}`);
	}

	create(data: Partial<Customer>): Observable<ApiResponse<Customer>> {
		return this.http.post<ApiResponse<Customer>>(`${this.apiUrl}/admin/customers`, data);
	}

	update(id: number, data: Partial<Customer>): Observable<ApiResponse<Customer>> {
		return this.http.put<ApiResponse<Customer>>(`${this.apiUrl}/admin/customers/${id}`, data);
	}
}
